<template>
  <div class="my-4 rounded-lg overflow-hidden">
    <iframe
      width="100%"
      height="415"
      :src="videoURL"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "embed-youtube",
  props: ["blok"],
  computed: {
    videoURL() {
      return this.blok.url;
    },
  },
};
</script>
